import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class TravellingMerchantSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.TRAVELLING_MERCHANT;
}

export default TravellingMerchantSalvageableTileEntity;
